import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import { handleFormSubmission } from 'public/formHandler.js';
import { saveLeadLog } from 'backend/handler.jsw';
import wixSeoFrontend from 'wix-seo-frontend';



$w.onReady(function () {
    console.log('v5')
  // Logs the title, e.g., "Page Title"
    console.log("url location",wixLocation.url);
    let splittedURL = wixLocation.url.split('?');
    console.log("splittedURL", splittedURL);

    //#region form new
    let urlSplitted = wixLocation.url.split("?");

    $w("#formNewsletter").setFieldValues({
        'link_pagina_form_newslettter': urlSplitted[0],
        'lingua_form_newslettter': wixWindow.multilingual.currentLanguage,
        "pagina_origine_newslettter" : wixSeoFrontend.title,
        "lead_status_form_newslettter": "Newsletter"
    })
    //#endregion

    
    
    

    //#region form old
    /**
     *	Adds an event handler that fires when a visitor submits a Wix Form and it is successfully received by the server.
    
    $w('#wixForms4').onWixFormSubmitted(async (event) => {

        let formMapping = {
            name: $w("#input19"),
            surname: $w("#input18"),
            email: $w("#input17"),
            phonePrefix: $w("#dropdown3"),
            phone: $w("#input16"),
            newsletter: $w("#checkbox7"),
            url: splittedURL[0],
            message: null,
            language: wixWindow.multilingual.currentLanguage,
            status: "Newsletter"
        }

        try {
            await handleFormSubmission(formMapping);
        } catch (error) {
            saveLeadLog("Form error masterpage:" + error)
            console.error('Errore durante la sottomissione del form:', error);

        }

    })
 */
    //#endregion

});
